import { LegalDocumentScreen, type LegalSection } from '@/components/account/LegalDocumentScreen';

const sections: LegalSection[] = [
  {
    heading: 'Data yang kami gunakan',
    paragraphs: [
      'Funpaper menggunakan data yang diperlukan untuk menyediakan layanan kepada orang tua. Data ini dapat mencakup informasi akun, profil anak seperti nama panggilan dan usia, preferensi kegiatan, serta worksheet yang dipilih dan aktivitas penggunaannya.',
    ],
  },
  {
    heading: 'Mengapa data digunakan',
    paragraphs: [
      'Kami menggunakan data tersebut untuk membuat rekomendasi aktivitas, menyimpan progres dan catatan aktivitas, menampilkan pengalaman yang sesuai, menjaga keamanan akun, serta memperbaiki kualitas Funpaper.',
    ],
  },
  {
    heading: 'Penyimpanan dan keamanan',
    paragraphs: [
      'Data disimpan pada layanan yang kami gunakan untuk menjalankan Funpaper dan dilindungi dengan langkah keamanan yang wajar. Tidak ada sistem yang sepenuhnya bebas dari risiko, tetapi kami berusaha membatasi akses hanya kepada pihak yang membutuhkannya.',
    ],
  },
  {
    heading: 'Berbagi data',
    paragraphs: [
      'Kami tidak menjual data pribadi. Data hanya dapat dibagikan jika diperlukan untuk menjalankan layanan, memenuhi kewajiban hukum, melindungi keamanan pengguna, atau ketika Anda memberikan izin.',
    ],
  },
  {
    heading: 'Profil anak dan kendali orang tua',
    paragraphs: [
      'Funpaper ditujukan untuk orang tua. Orang tua bertanggung jawab atas informasi yang dimasukkan ke profil anak dan dapat meminta perubahan atau penghapusan data melalui fitur yang tersedia atau dengan menghubungi kami.',
    ],
  },
  {
    heading: 'Pertanyaan dan perubahan kebijakan',
    paragraphs: [
      'Jika ada pertanyaan tentang privasi atau ingin meminta bantuan terkait data, hubungi terusmengajar@gmail.com. Kami dapat memperbarui kebijakan ini jika fitur atau cara kerja Funpaper berubah. Perubahan akan ditampilkan di halaman ini.',
    ],
  },
];

export default function KebijakanPrivasiScreen() {
  return (
    <LegalDocumentScreen
      title="Kebijakan Privasi"
      intro="Kami menghargai kepercayaan orang tua yang menggunakan Funpaper. Halaman ini menjelaskan secara sederhana bagaimana kami menggunakan dan melindungi informasi saat Anda memakai aplikasi."
      sections={sections}
    />
  );
}
